module.exports = __webpack_public_path__ + "img/fitnessbg1.dd982487.png";